module.exports = "<div ui-view></div>"


//////////////////
// WEBPACK FOOTER
// ../~/noop-loader!./components/xo-wallet-components/src/add-card/template.html
// module id = ../node_modules/noop-loader/index.js!./components/xo-wallet-components/src/add-card/template.html
// module chunks = 1